import React from "react";
import { Label, DropdownBox, InputField } from "client/CommonComponents";

const AddApplicationPermission = ({
  handleChange,
  formError,
  form,
  applicationDropDown,
  appAreaDropDownVal
}: any) => {

  return (
    <div className="appPermissionPopUp">
      <div className="pool-grid-block">
        <div>
          <Label required data-attribute="AddApplicationPermission_Default_Label">Name</Label>
          <InputField
            placeholder="Name"
            name="nameVal"
            onChange={handleChange}
            value={form?.nameVal}
           data-attribute="AddApplicationPermission_nameVal_Input" />
          {formError?.nameValError ? (
            <span className="asset-validation-msg">
              {formError?.nameValError}
            </span>
          ) : null}
        </div>
        <div className="fieldTopPadding">
          <Label required data-attribute="AddApplicationPermission_Default_Label_2">Application Name</Label>
          <DropdownBox
            name="appName"
            placeholder="select Application Name"
            onChange={handleChange}
            options={applicationDropDown?.length > 0 ? applicationDropDown : [{text:"Select App Area", key:null}]}
            value={form?.appName.key}
            selectedKey={form?.appName.key}
           data-attribute="AddApplicationPermission_appName_Dropdown" />
          {formError?.appNameError ? (
            <span className="asset-validation-msg">
              {formError?.appNameError}
            </span>
          ) : null}
        </div>
        <div className="fieldTopPadding">
          <Label required data-attribute="AddApplicationPermission_Default_Label_3">Application Area</Label>
          <DropdownBox
            name="appArea"
            placeholder="select Application Area"
            value={form?.appArea?.key}
            selectedKey={form?.appArea?.key}
            onChange={handleChange}
            options={appAreaDropDownVal?.length > 0 ? appAreaDropDownVal : [{text:"Select App Area", key:null}]}
           data-attribute="AddApplicationPermission_appArea_Dropdown" />
          {formError?.appAreaError ? (
            <span className="asset-validation-msg">
              {formError?.appAreaError}
            </span>
          ) : null}
        </div>
        <div className="fieldTopPadding">
          <Label required data-attribute="AddApplicationPermission_Default_Label_4">Permission Description</Label>
          <InputField
            placeholder="Permission Description"
            name="permissionDesc"
            onChange={handleChange}
            value={form?.permissionDesc}
           data-attribute="AddApplicationPermission_permissionDesc_Input" />
          {formError?.permissionDescError ? (
            <span className="asset-validation-msg">
              {formError?.permissionDescError}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AddApplicationPermission;
